import * as types from '../mutation-types';
import { UserApi, RateApi, ReferencesApi } from '../../services/api';
import * as pagination from '../pagination';
import globalStore from '../index';

const userApi = new UserApi();
const rateApi = new RateApi();
const referencesApi = new ReferencesApi();

const state = {
    user: null,
    registerData: null,
    badges: [],
    ...pagination.makeState('rates')
};

const getters = {
    user: (state) => state.user,
    registerData: (state) => state.registerData,
    badges: (state) => state.badges,
    references: (state) => {
        if (state.user) {
            return state.user.references_data;
        } else {
            return null;
        }
    },
    ...pagination.makeGetters('rates')
};

const actions = {
    setUser(store, user) {
        store.commit(types.PROFILE_SET_USER, user);
        store.dispatch('ratesSearch');
        if (user && user.id) {
            store.dispatch('profile/fetchBadges', user.id);
        }
    },

    setUserByID(store, { id, userProfile }) {
        if (userProfile) {
            store.commit(types.PROFILE_SET_USER, userProfile);
        }
        return userApi
            .show(id)
            .then((response) => {
                store.commit(types.PROFILE_SET_USER, response.data);
                store.dispatch('ratesSearch');
                store.dispatch('profile/fetchBadges', id);
                return Promise.resolve(response.data);
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    },

    fetchBadges(store, userId) {
        return userApi
            .getBadges(userId)
            .then((response) => {
                const badges = response.data.data || response.data;
                store.commit(types.PROFILE_SET_BADGES, Array.isArray(badges) ? badges : []);
                return Promise.resolve(badges);
            })
            .catch(() => {
                store.commit(types.PROFILE_SET_BADGES, []);
                return Promise.resolve([]);
            });
    },
    registerDonation(store, data) {
        return userApi
            .registerDonation(data)
            .then((response) => {
                globalStore.commit(
                    'auth/' + types.DONATION_INTENT_PUSH,
                    response.donation
                );
                return Promise.resolve();
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    },

    getBankData(store, data) {
        return userApi
            .getBankData(data)
            .then((response) => {
                console.log('getBankData', response);
                return Promise.resolve(response);
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    },

    getTermsText(store, data) {
        return userApi
            .getTermsText(data)
            .then((response) => {
                console.log('getTermsText', response);
                return Promise.resolve(response);
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    },

    changeProperty(store, data) {
        return userApi
            .changeProperty(data)
            .then((response) => {
                console.log('changeProperty', response);
                // store.commit(types.PROFILE_SET_USER, response.data);
                if (!response.user && response.data) {
                    response.user = response.data;
                }
                globalStore.commit(
                    'auth/' + types.AUTH_SET_USER,
                    response.user
                );
                return Promise.resolve();
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    },

    saveRegisterData({ commit }, data) {
        commit(types.PROFILE_SAVE_REGISTER_DATA, data);
    },

    cleanRegisterData({ commit }) {
        commit(types.PROFILE_CLEAN_REGISTER_DATA);
    },

    makeReference({ commit }, data) {
        return referencesApi
            .create(data)
            .then((response) => {
                commit(types.PROFILE_REFERENCE_ADD, response);
                return Promise.resolve(response);
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    },

    ...pagination.makeActions('rates', ({ store, data }) => {
        // TODO: Pagination not working
        data.page_size = 200;
        return rateApi.index(store.state.user.id, data);
    })
};

const mutations = {
    ...pagination.makeMutations('rates'),

    [types.PROFILE_SET_USER](state, user) {
        state.user = user;
        state.badges = [];
    },

    [types.PROFILE_SET_BADGES](state, badges) {
        state.badges = badges;
    },

    [types.PROFILE_SET_REPLY](state, rate) {
        state.rates.forEach((item) => {
            if (
                rate.trip_id === item.trip.id &&
                rate.user_id === item.from.id
            ) {
                rate.reply_comment = item.comment;
                rate.reply_comment_created_at = item.reply_comment_created_at;
            }
        });
    },

    [types.PROFILE_SAVE_REGISTER_DATA](state, data) {
        state.registerData = data;
    },

    [types.PROFILE_CLEAN_REGISTER_DATA](state, data) {
        state.registerData = null;
    },

    [types.PROFILE_REFERENCE_ADD](state, reference) {
        if (!state.user.references_data) {
            state.user.references_data = [];
        }
        console.log('PROFILE_REFERENCE_ADD', state.user);
        state.user.references_data.push(reference);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
